import { useState, useEffect } from "react";
import Txn from "./Txn";
import { ListHeader, OpenCloseBalance } from "components";
import { transactionAPI } from "services";
import useUniversalStore from "store/universalStore";
import { Loader } from 'components';
import { formatMoney } from "utils";

const TxnList = ({ currentDate, animation, setAnimation, hideClosed}) => {
    const txns = useUniversalStore((state) => state.transactions);
    const [openBalance, setOpenBalance] = useState(0);
    const [closeBalance, setCloseBalance] = useState(0);
    const [loading, setLoading] = useState(true);
    const [filteredTnx, setFilteredTnx] = useState(txns);
    const [dailyCash, setDailyCash] = useState({
      in: 0,
      out: 0
    });

    useEffect(()=>{
      if (hideClosed) {
        const filtered = txns?.filter((item) => !item.get("cancelled"));
        setFilteredTnx(filtered);
      } else {
        setFilteredTnx(txns);
      }
    },[txns,hideClosed])

    useEffect(() => {
        setLoading(true);
      
        calculateOpenCloseBalance();
        dailyCashInOut();

        setLoading(false);
    }, [currentDate,txns]);

    const calculateOpenCloseBalance = async() => {
      const openDate = new Date(currentDate.getFullYear(),currentDate.getMonth(), currentDate.getDate(),0,0,0,0);
      const closeDate = new Date(currentDate.getFullYear(),currentDate.getMonth(),currentDate.getDate(),23,59,59,999);
      
      await  transactionAPI.sumTillDate(openDate).then((res) => setOpenBalance(res));
      await  transactionAPI.sumTillDate(closeDate).then((res) => setCloseBalance(res));
    }

    const dailyCashInOut = async() => {
      transactionAPI.dailyCashInOut(currentDate, "in")
        .then((res) => {
            setDailyCash({
              ...dailyCash,
              in: formatMoney(Math.abs(res))
            })
        });
      transactionAPI.dailyCashInOut(currentDate, "out")
      .then((res) => {
        setDailyCash({
          ...dailyCash,
          out: formatMoney(Math.abs(res))
        })
      });
    }

    if(loading) return <Loader />;

    return (
        <div className={`row background ${animation}`} 
          onAnimationEnd={() => setAnimation("")}>
            <div className="col-6 col-md-6 list-group list-group-flush overflow-scroll scrollbar-design"
              style={{ height: 'calc(100vh - 150px)', maxHeight: 'calc(100vh - 150px)' }}>
              <ListHeader type="in" amount={dailyCash.in} />
              <OpenCloseBalance type="open" sum={openBalance} />
              {filteredTnx?.filter((txn) => txn.get("amount") > 0)
                .filter((txn) => !txn.cancelled)
                .map((txn, i) => (
                  <Txn data={txn} key={i} currentDate={currentDate} setLoading={setLoading} />
                ))}
            </div>
            <div className="col-6 col-md-6 list-group list-group-flush overflow-scroll scrollbar-design"
              style={{ height: 'calc(100vh - 150px)', maxHeight: 'calc(100vh - 150px)' }}>
              <ListHeader type="out" amount={dailyCash.out} />
              {filteredTnx?.filter((txn) => txn.get("amount") < 0)
                .filter((txn) => !txn.cancelled)
                .map((txn, i) => (
                  <Txn data={txn} key={i} currentDate={currentDate} setLoading={setLoading} />
                ))}
              <OpenCloseBalance type="close" sum={closeBalance} />
            </div>
        </div>
    );
};

export default TxnList;